import type { ReadonlyJSONValue } from "@rocicorp/zero";
import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { Step } from "../components/Step";
import { Text } from "../components/Text";

function parseInput(toolUse: ToolUseProps["toolUse"]) {
  const v = toolUse.input;
  return v && typeof v === "object" && !Array.isArray(v)
    ? (v as Record<string, ReadonlyJSONValue>)
    : null;
}

function str(v: ReadonlyJSONValue | undefined): string | undefined {
  return typeof v === "string" ? v : undefined;
}

function ExecuteHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const input = parseInput(toolUse);

  return (
    <Step
      color="var(--gray-600)"
      done={!!result}
      interrupted={interrupted}
      pastParticiple={str(input?.completedDescription) ?? "Done"}
      inProgress={
        str(input?.activeDescription)
          ? `${str(input?.activeDescription)}…`
          : "Working…"
      }
    />
  );
}

function ExecuteBody({ toolUse, result }: ToolUseProps) {
  const input = parseInput(toolUse);
  const code = str(input?.code);

  return (
    <Text variant="code-small" color="var(--text-secondary)">
      {code && (
        <pre
          style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {code}
        </pre>
      )}
      {result && (
        <pre
          style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {JSON.stringify(result.output, null, 2)}
        </pre>
      )}
    </Text>
  );
}

export const execute: ChatTool = {
  name: "execute",
  Header: ExecuteHeader,
  Body: ExecuteBody,
};
